import * as React from 'react';
import { VoidFunc } from 'types/types';

import './ToggleButton.pcss';

interface ToggleButton_P {
  on:boolean,
  disabled:boolean;
  onClick:VoidFunc
}

export const ToggleButton = (props:ToggleButton_P) => 
  <div className={`toggleButton${props.on?' on':''}${props.disabled?' disabled':''} noselect`} onClick={()=>{ if(!props.disabled) { props.onClick(); }}}> 
    <div className="indicator"><i className='material-icons'>{props.on?'check':'close'}</i></div>
  </div>
;
